import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ElasticLogAction } from '../models/elastic-log-action.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class ElasticLogService {

    private _url: string = environment.apiElasticLogUrl;
    constructor(private _httpClient: HttpClient) { }

    public callEmployerAction(action: ElasticLogAction): void {
        this._httpClient.post(this._url, action, {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
            .subscribe(res => {
                console.log('done');
            },
                error => {
                    console.log('failed: ' + error.statusText + '\n' + error.status + '\n' + error.responseText);
                });
    }
}
